import { render } from "./OtherPaymentsHistory.vue?vue&type=template&id=28055d62&scoped=true"
import script from "./OtherPaymentsHistory.vue?vue&type=script&lang=js"
export * from "./OtherPaymentsHistory.vue?vue&type=script&lang=js"

import "./OtherPaymentsHistory.vue?vue&type=style&index=0&id=28055d62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28055d62"]])

export default __exports__